import { useEffect, useRef, useState } from 'react';
import { VerticalLayout } from '../../common/common-layout';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import { useHideMenu } from '../../hooks/useHideMenu';
import { useScrollMenuHandler } from '../../hooks/useScrollMenuHandler';
import { useSectionInView } from '../../hooks/useSectionInView';
import menuStore from '../../store/MenuStore';
import FooterSection from '../base/FooterSection';
import FooterSectionMobile from '../base/FooterSectionMobile';
import HistorySection1 from './HistorySection1';
import HistorySection2 from './HistorySection2';

const IntroduceHistoryPage = () => {
  const { isMobile } = useDeviceType();
  useScrollMenuHandler();
  useHideMenu();

  const section1Ref = useRef<HTMLDivElement>(null);
  const inView1 = useSectionInView(section1Ref);
  const [showFooter, setShowFooter] = useState(false);

  useEffect(() => {
    menuStore.setBackgroundColor('transparent');
  }, []);

  useEffect(() => {
    menuStore.setDarkMode(inView1);
  }, [inView1]);

  return (
    <VerticalLayout>
      <div ref={section1Ref} style={{ width: '100%', overflow: 'hidden', 
        ...(isMobile ? {} : { aspectRatio: '1913 / 1048' }),
       }}>
        <HistorySection1 />
      </div>
      <div style={{ width: '100%', overflowX: 'hidden' }}>
        <HistorySection2 onFullyExpandedChange={(done) => {
          setShowFooter(done);
        }} />
      </div>
      {showFooter && (
        <div style={{ width: '100%', overflowX: 'hidden' }}>
          {isMobile ? <FooterSectionMobile /> : <FooterSection />}
        </div>
      )}
    </VerticalLayout>
  );
};

export default IntroduceHistoryPage;
